import { createBrowserRouter } from 'react-router-dom';
import routes from 'domain/router/routes';

const router = createBrowserRouter(routes);

export default router;
